import { useState, useEffect } from 'react';
import { Capacitor } from "@capacitor/core";
import { Contacts } from "@capacitor-community/contacts";

type ErrorCallback = (errorType: 'permission' | 'fetch') => void;

const useContacts = (onError: ErrorCallback) => {
  const [contacts, setContacts] = useState<any[]>([]);

  useEffect(() => {
    Capacitor.isNativePlatform() && requestContactsPermission();
  }, []);

  const requestContactsPermission = async () => {
    try {
      const permission = await Contacts.requestPermissions();
      if (permission.contacts === "granted") {
        await fetchContacts();
      } else {
        onError('permission');
      }
    } catch (error) {
      console.error("Error requesting contacts permission:", error);
      onError('permission');
    }
  };

  const fetchContacts = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        const result = await Contacts.getContacts({
          projection: { name: true, phones: true },
        });
        if (result && result.contacts && Array.isArray(result.contacts)) {
          setContacts(result.contacts);
        } else {
          console.warn("No contacts found or contacts are not in expected format");
          setContacts([]);
        }
      } else {
        console.warn("Contacts API is only available on native platforms");
        setContacts([]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setContacts([]);
      onError('fetch');
    }
  };

  return { contacts };
};

export default useContacts